const dropdownContainerClassName = "custom-dropdown-container";

export { dropdownContainerClassName };
